import React, { useState, useRef } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { signInUser } from "../../Utility/Auth";
import { useDispatch } from "react-redux";
import { addToCartReducer } from "../../../features/posSlice";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// Debounce helper to prevent keystroke hammering
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const SelectProduct = ({ addToList, supplierProductsRef }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const selectRef = useRef(null);
  const cancelTokenRef = useRef(null);

  const dispatch = useDispatch();

  const pnpMc = [54, 59, 61]; // Array to check for PNP products
  let qty = 1;

  // Internal data fetching logic
  // Internal data fetching logic
  const fetchDataInternal = async (inputValue, callback) => {
    const auth = signInUser();
    if (!auth) {
      callback([]);
      return;
    }

    const { aamarId } = auth;
    const warehouse =
      auth?.warehouse &&
      auth.warehouse !== "undefined" &&
      auth.warehouse !== "null"
        ? auth.warehouse
        : "allWh";

    // Cancel the previous request if it exists
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel("Cancel The Previous Request");
    }

    // Create a new cancel token
    cancelTokenRef.current = axios.CancelToken.source();

    const articleCodeStr = (inputValue || "").toString().trim();
    const startsWithAny = pnpMc.some((item) =>
      articleCodeStr.startsWith(item.toString())
    );

    if (startsWithAny && articleCodeStr.length >= 12) {
      const wBefore = articleCodeStr.substring(7, 9);
      const wAfter = articleCodeStr.substring(9, 12);
      qty = `${wBefore}.${wAfter}`;
    } else {
      qty = 1;
    }

    try {
      const baseUrl = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
      const url = articleCodeStr
        ? `${baseUrl}product/search/${aamarId}/${warehouse}/${encodeURIComponent(
            articleCodeStr
          )}`
        : `${baseUrl}product/search/${aamarId}/${warehouse}`;

      const result = await axios.get(url, {
        cancelToken: cancelTokenRef.current.token,
      });

      const tempArray = [];
      const products = Array.isArray(result?.data) ? result.data : [];

      if (products.length > 0) {
        products.forEach((element) => {
          const activePrices = Array.isArray(element?.priceList)
            ? element.priceList
            : [];
          const priceItem = activePrices[0];
          const mrp = priceItem?.mrp ?? 0;
          const priceId = priceItem?._id || "";

          tempArray.push({
            label: `${element?.name || ""} - [ ${element?.article_code || ""} ] ${mrp} BDT - Stock: ${element?.stock ?? 0} ${element?.unit || ""}`,
            value: element?._id,
            price: priceId,
            product: element,
          });
        });

        // Exact barcode match auto-selection (e.g. barcode scanner)
        if (products.length === 1 && articleCodeStr) {
          const pro = products[0];
          const isExactBarcode =
            pro?.article_code === articleCodeStr ||
            pro?.ean === articleCodeStr ||
            (articleCodeStr.length >= 7 && startsWithAny);

          if (isExactBarcode) {
            const activePrices = Array.isArray(pro?.priceList)
              ? pro.priceList
              : [];
            const proPrice = activePrices[0]?._id;
            if (proPrice) {
              getValue(pro._id, proPrice);
            }
          }
        }
      }

      callback(tempArray);
    } catch (error) {
      if (axios.isCancel(error)) {
        // Request was cancelled due to new input, normal behavior
      } else {
        console.error("Error fetching product search:", error);
        callback([]);
      }
    }
  };

  // Debounced search trigger
  const debouncedFetchData = useRef(
    debounce((inputValue, callback) => {
      fetchDataInternal(inputValue, callback);
    }, 300)
  ).current;

  // Immediate fetch for initial/empty suggestions, debounced for typed queries
  const loadOptionsHandler = (inputValue, callback) => {
    if (!inputValue || !inputValue.trim()) {
      fetchDataInternal("", callback);
    } else {
      debouncedFetchData(inputValue, callback);
    }
  };

  // GET VALUE OF SELECTED ITEM
  const getValue = async (data, price) => {
    if (!data) return;

    try {
      const baseUrl = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
      const result = await axios.get(`${baseUrl}product/${data}`);

      if (result?.data) {
        const set = dispatch(
          addToCartReducer({ data: result.data, price: price, qty: qty })
        );

        if (set === false) {
          qty = 1;
          selectRef.current?.focus?.();
          supplierProductsRef?.current?.focus?.();
        }
      }
    } catch (error) {
      console.error("Error getting product value:", error);
    }
  };

  // HANDLE SELECT
  const handleSearchChange = (selected) => {
    if (selected && selected.value) {
      setSelectedOption(null);
      getValue(selected.value, selected.price);
    }
  };

  return (
    <AsyncSelect
      value={selectedOption}
      loadOptions={loadOptionsHandler}
      placeholder="Product Search"
      onChange={handleSearchChange}
      defaultOptions={true}
      openMenuOnFocus={true}
      classNamePrefix="react-select"
      innerRef={selectRef}
      ref={supplierProductsRef}
    />
  );
};

export default SelectProduct;
